var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address mt-4"},[_c('div',{class:{
            'input-focus-effect': true,
            'rv-valiadate-input-form': _vm.error
        }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],class:_vm.address != '' ? 'border-primary' : '',attrs:{"type":"text","id":"inputAddress"},domProps:{"value":(_vm.address)},on:{"focus":function($event){return _vm.$emit('update:error', '')},"input":function($event){if($event.target.composing)return;_vm.address=$event.target.value}}}),_c('label',{class:{
                'mb-0': true,
                'input-on-alue': _vm.address != ''
            }},[_vm._v("Địa chỉ")])]),(_vm.error)?_c('div',{staticClass:"text-danger fs-12px mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }